import { useEffect } from "react";
import {
	Navigate,
	Route,
	Routes,
	useLocation,
} from "react-router-dom";
import { guestRoutes } from "../../src/routes/routeConfig";
import { GUEST_ROUTE } from "../lib/constants";

/**
 * Routes only a logged out user could visit.
 */
/**
 * @description
 * useEffect statement handles redirecting a user to login if they attempt to view an authenticated URL.
 *
 * @example
 * An unauthenticated user opens an email notification link to view a transaction they recieved, which sends them to a route which only an authenticated
 * user has access to, for example:
 * `View Transaction` ---> `/transactions?transactionId=5fbc1d5c61e3580009b0f648`
 *
 * In this case, we need to redirect the user to the signin page & pass the intended
 * destination url as a param like so:
 * /login?session_redirect=/transactions?transactionId=5fbc1d5c61e3580009b0f648
 *
 * Without this method, an unauthenticated user who visits an authenticated route
 * will hit a blank page, since unauthenticated users don't have access to authenticated routes.
 */
export const UnAuthenticatedRoutes = (): JSX.Element => {
	const location = useLocation();

	// scroll to up when push a new page
	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return (
		<Routes>
			{guestRoutes.map((route, index) => (
				<Route key={index} {...route} />
			))}
			<Route
				path={GUEST_ROUTE.HOME}
				element={<Navigate to={GUEST_ROUTE.LOGIN} replace />}
			/>
			<Route
				path="*"
				element={
					<Navigate
						to={GUEST_ROUTE.LOGIN}
						state={{ redirectTo: location.pathname, redirectState: {} }}
						replace
					/>
				}
			/>
		</Routes>
	);
};
